import OfferHero from './OfferHero';

export default OfferHero;
